import React from 'react';
import styled, { css } from 'styled-components';
import { sectionMargins } from '../styles';
import { Container, Video } from './ui';

const StyledInternalVideo = styled.section`
  ${({ isDetail }) => {
    if (isDetail) {
      return css`
        ${sectionMargins('20px', '40px')};
      `;
    } else {
      return css`
        ${sectionMargins()};
      `;
    }
  }}
`;

const InternalVideo = ({ video, videoThumbnailSeconds, isDetail }) => (
  <StyledInternalVideo isDetail={isDetail}>
    <Container>
      <Video
        data={video}
        thumbnailSeconds={videoThumbnailSeconds}
        isDetail={isDetail}
      />
    </Container>
  </StyledInternalVideo>
);

export default InternalVideo;
